import { App } from "vue";

import ZButton from "./base/ZButton.vue";
import ZJumbotron from "./base/ZJumbotron.vue";
import ZCard from "./base/ZCard.vue";
import ZTable from "./utils/ZTable.vue";
import ZVirtualTable from "./utils/ZVirtualTable.vue";
import ZModal from "./utils/ZModal.vue";


import TitleWithSubtitle from "./app/TitleWithSubtitle.vue";

export interface BaseGlobalComponents {
  ZJumbotron: typeof ZJumbotron;
  ZCard: typeof ZCard;
  ZTable: typeof ZTable;
  ZVirtualTable: typeof ZVirtualTable;
  ZButton: typeof ZButton;
  ZModal: typeof ZModal;
}

export function registerComponents(app: App) {
  app
    .component('title-with-subtitle', TitleWithSubtitle)
    .component('z-jumbotron', ZJumbotron)
    .component('z-card', ZCard)
    .component('z-table', ZTable)
    .component('z-virtual-table', ZVirtualTable)
    .component('z-button', ZButton)
    .component('z-modal', ZModal)
}